import React from 'react'
import { Dropdown, DropdownItem, DropdownMenuPosition } from '@duik/it'
import TableRow from '../../UI/TableRow'
import cls from '../../styles/Header.scss'
import EditIcon from '@material-ui/icons/CreateRounded'
import LocationIcon from '@material-ui/icons/LocationOnRounded'
import MoreIcon from '@material-ui/icons/MoreHoriz'
import ToolTip from '../../UI/ToolTip'
import Avatar from '../../UI/Avatar'
import { SingleItemClickable, LeftSideColor, colors } from '../../UI/TableItem'
import styled from '@emotion/styled'

type Props = {
  site: {
    _id: string
    siteName: string
    company: string
    location: string
    city: string
    province: string
    coordinates: {
      lat: number
      lng: number
    }
    delete: string
    companyId: string
    customCoordinates: {
      lat: number
      lng: number
    }
    brokerCompanyIds?: string[]
    type?: string
  }
  editSiteModalToggle(_id: string): void
  siteViewModalToggle(_id: string): void
  siteDeleteModalToggle(_id: string): void
  geofencedSiteViewModalToggle(_id: string, editable?: boolean): void
  index: number
  companyId: string
}

const StyledAvatar = styled.td`
  display: flex;
`

const SiteNameText = styled.span`
  font-size: 16px;
  align-self: center;
`

const IconsContainer = styled.td`
  text-align: right;
`

const SiteItem = ({
  site,
  editSiteModalToggle,
  siteViewModalToggle,
  siteDeleteModalToggle,
  index
}: Props) => {
  const openSite = () => {
    siteViewModalToggle(site._id)
  }

  const editSite = () => {
    editSiteModalToggle(site._id)
  }

  return (
    <TableRow key={site._id}>
      <StyledAvatar style={{ display: 'flex' }} className={'cursor-pointer'} onClick={openSite}>
        <Avatar
          content={`${site.siteName.charAt(0)}${site.siteName.charAt(1)}`}
          color={colors[LeftSideColor(index).index]}
        />
        <SiteNameText>{site.siteName}</SiteNameText>
      </StyledAvatar>
      <SingleItemClickable text={site.company} id={site._id} onClick={openSite} width="23" />
      <SingleItemClickable text={site.city} id={site._id} onClick={openSite} width="17" />
      <SingleItemClickable
        text={site.type ? site.type : '-'}
        id={site._id}
        onClick={openSite}
        width="16"
      />

      <IconsContainer>
        <ToolTip title="Edit">
          <EditIcon
            onClick={editSite}
            style={{ fill: '#555858 !important' }}
            className="actionsIcon"
          />
        </ToolTip>
        <ToolTip title={site.customCoordinates ? 'View Geo-fence' : 'View Map'}>
          <LocationIcon
            onClick={() => siteViewModalToggle(site._id)}
            style={{ fill: '#6B6C6F' }}
            className="actionsIcon"
          />
        </ToolTip>
        <Dropdown
          className={cls.dropdownFilter}
          ButtonComponent={(props: any) => (
            <MoreIcon
              className="actionsIcon"
              onClick={props.handleToggle}
              style={{ fill: '#6B6C6F' }}
            />
          )}
          menuPosition={DropdownMenuPosition['bottom-left']}
          closeOnOptionClick
        >
          <DropdownItem
            onClick={() => {
              siteDeleteModalToggle(site._id)
            }}
          >
            Delete
          </DropdownItem>
        </Dropdown>
      </IconsContainer>
    </TableRow>
  )
}

export default SiteItem
